/** @jsxImportSource @emotion/react */

import { useState, FC } from "react";
import { css } from "@emotion/core";
import pasargadBank from "../../assets/images/Pasargad_Bank.png";
import testBankIMG from "../../assets/images/testBank.jpg";
import POST_BANK from "../../assets/images/POST_Bank.png";
import Text from "ui-modules/components/DataDisplay/Text";
import Ripple from "ui-modules/components/Misc/Ripple";
import Skeleton from "ui-modules/components/Misc/Skeleton";
import useTheme from "ui-modules/commons/hooks/use-theme";
// import sepahBank from "../../assets/images/Sepah_Bank.png";
// import podBank from "../../assets/images/Pod_Bank.png";
// import keshavarziBank from "../../assets/images/Keshavarzi_Bank.png";

type BanksProps = {
  onSelect: (bank: string) => void;
  loading?: boolean;
  testPasargad?: "PASARGAD_NEW" | "POST_BANK";
};

const Banks: FC<BanksProps> = (props) => {
  const theme = useTheme();

  const { loading = false, onSelect, testPasargad } = props;

  const [bank, setBank] = useState("PASARGAD");

  const handleSelectBank = (selectedBank: string) => {
    if (selectedBank !== null) {
      onSelect(selectedBank);
      setBank(selectedBank);
    }
  };

  const styles = {
    wrapper: css`
      button {
        width: 150px;
        height: auto;
        border: none;
        margin: 10px 10px;
        padding: 10px;
        background: ${theme.bodyBackground};
        border-radius: 4px !important;
        outline: none;

        img {
          width: 60px;
          filter: grayscale(100%);
          padding: 5px 0;
        }
      }

      .${bank}-IMG {
        filter: inherit !important;
      }

      .${bank}-BUTTON {
        border: 1px solid ${theme.material.textDisabledOnLight};
      }
    `,
    bankGroup: css`
      margin-top: 15px;
      display: flex;
      justify-content: center;
      @media (max-width: 1440px) {
        display: inherit;
      }
    `,
    loading: css`
      margin: 10px 10px;
    `,
  };

  const renderPasargadNew = () => {
    if (testPasargad) {
      if (loading) {
        return <Skeleton width={150} height={110} css={styles.loading} />;
      } else {
        return (
          <Ripple>
            <button
              className="PASARGAD_NEW-BUTTON"
              onClick={() => handleSelectBank(testPasargad)}
              aria-label="center aligned"
            >
              <img src={testBankIMG} alt={"PASARGAD_NEW bank"} className="PASARGAD_NEW-IMG" />
              <Text type={"textHint"}>{testPasargad}</Text>
            </button>
          </Ripple>
        );
      }
    }
    return null;
  };

  return (
    <div css={styles.wrapper}>
      <div css={styles.bankGroup}>
        {loading ? (
          <Skeleton width={150} height={110} css={styles.loading} />
        ) : (
          <Ripple>
            <button
              className="PASARGAD-BUTTON"
              onClick={() => handleSelectBank("PASARGAD")}
              aria-label="center aligned"
            >
              <img src={pasargadBank} alt={"pasargad bank"} className="PASARGAD-IMG" />
              <Text type={"textHint"}>بانک پاسارگاد</Text>
            </button>
          </Ripple>
        )}
        {/*{loading ? (*/}
        {/*  <Skeleton width={150} height={110} css={styles.loading} />*/}
        {/*) : (*/}
        {/*  <Ripple>*/}
        {/*    <button*/}
        {/*      className="KESHAVARZI-BUTTON"*/}
        {/*      onClick={() => handleSelectBank("KESHAVARZI")}*/}
        {/*      aria-label="center aligned"*/}
        {/*    >*/}
        {/*      <img src={keshavarziBank} alt={"keshavarzi bank"} className="KESHAVARZI-IMG" />*/}
        {/*      <Text type={"textHint"}>بانک کشاورزی</Text>*/}
        {/*    </button>*/}
        {/*  </Ripple>*/}
        {/*)}*/}
        {loading ? (
          <Skeleton width={150} height={110} css={styles.loading} />
        ) : (
          <Ripple>
            <button
              className="POST_BANK-BUTTON"
              onClick={() => handleSelectBank("POST_BANK")}
              aria-label="center aligned"
            >
              <img src={POST_BANK} alt={"post bank"} className="POST_BANK-IMG" />
              <Text type={"textHint"}>پست بانک ایران</Text>
            </button>
          </Ripple>
        )}
        {renderPasargadNew()}
        {/*{loading ? (*/}
        {/*  <Skeleton width={150} height={110} css={styles.loading} />*/}
        {/*) : (*/}
        {/*  <Ripple>*/}
        {/*    <button className="SAMAN-BUTTON" onClick={() => handleSelectBank("SAMAN")} aria-label="center aligned">*/}
        {/*      <img src={sepahBank} alt={"saman bank"} className="SAMAN-IMG" />*/}
        {/*      <Text type={"textHint"}>بانک سپه</Text>*/}
        {/*    </button>*/}
        {/*  </Ripple>*/}
        {/*)}*/}
        {/*{loading ? (*/}
        {/*  <Skeleton width={150} height={110} css={styles.loading} />*/}
        {/*) : (*/}
        {/*  <Ripple>*/}
        {/*    <button*/}
        {/*      className="POD-BUTTON"*/}
        {/*      // style={{ cursor: "not-allowed" }}*/}
        {/*      onClick={() => handleSelectBank("POD")}*/}
        {/*      aria-label="center aligned"*/}
        {/*    >*/}
        {/*      <img src={podBank} alt={"POD"} className="POD-IMG" />*/}
        {/*      <Text type={"textHint"}>درگاه پرداخت پاد</Text>*/}
        {/*    </button>*/}
        {/*  </Ripple>*/}
        {/*)}*/}
      </div>
    </div>
  );
};
export default Banks;
